<div class="avatar-wrapper">
	@if (authService.user$ | async; as user) {
		<div class="user-email">
			{{ user.email }}
		</div>
	}
	<div class="logout-container">
		<a (click)="logout()">Logout</a>
	</div>
</div>
